import { Link } from "react-router-dom";

const SRC = "/brand/speedy-resurfacing-logo-960.webp";
// 480w → 1x phones, 960w → retina, 1893w → native master for 3x/4k+ screens.
const SRCSET = "/brand/speedy-resurfacing-logo-480.webp 480w, /brand/speedy-resurfacing-logo-960.webp 960w, /brand/speedy-resurfacing-logo-1893.webp 1893w";
const CROWN = "/brand/crown-ornate-640.webp";

// Official Speedy Resurfacing lockup — gold frame, gold "SPEEDY", chrome "RESURFACING", transparent surround,
// with the ornate crown perched on the top-right corner, tilted slightly to the right.
export default function Logo({ compact = false, size = "nav" }) {
  const h = compact ? "h-9" : size === "footer" ? "h-16 sm:h-20" : "h-12 sm:h-14 md:h-16";
  const px = compact ? "84px" : size === "footer" ? "(min-width: 640px) 182px, 146px" : "(min-width: 768px) 146px, (min-width: 640px) 128px, 110px";
  return (
    <Link to="/" className="group relative inline-flex items-center" data-testid="logo-link" aria-label="Speedy Resurfacing — home">
      <img
        src={SRC}
        srcSet={SRCSET}
        sizes={px}
        alt="Speedy Resurfacing"
        decoding="async"
        fetchpriority="high"
        className={`w-auto select-none logo-glow transition-transform duration-300 group-hover:scale-[1.03] ${h}`}
      />
      <img
        src={CROWN}
        alt=""
        aria-hidden="true"
        decoding="async"
        data-testid="logo-crown"
        className="logo-crown pointer-events-none absolute -top-[26%] right-[-3%] h-[44%] w-auto select-none rotate-[14deg] origin-bottom-left transition-transform duration-300 group-hover:rotate-[18deg] group-hover:scale-[1.06]"
      />
    </Link>
  );
}
